<template>
	<div class="part">
		<div v-html="part.PartEnunciado" class="enunciado">
		</div>
		<div class="info">
			You will have <strong>{{ part.PartTempoLeituraPerguntas }} seconds</strong> to read the questions before the audio starts. The audio will be played twice automatically.
		</div>
		<div class="button">
			<button @click="start" class="btn btn-lg btn-pink">Start</button>
		</div>
	</div>
</template>


<script>
	export default {
		props: ['part'],
		
		methods: {
			start() {
				this.$emit("started");
			}
		}
	}
</script>


// WEBPACK FOOTER //
// src/components/perguntas/audio/Start.vue